export default __webpack_public_path__ + "static/media/patient.711de1f3.svg";